import { connect } from 'react-redux'
import ThemeWrapper from './ThemeWrapper'

const mapStateToProps = state => ({
  configuration: state.configuration
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeWrapper)
